import { object, string, boolean, number } from "yup";
import { SchemaOf } from "yup";
import { IPafClientForm } from "../../_api";
import { companyAEFields } from "../../_appData";

/**
 * When isListAdmin is true, ListOwner-only fields (parent_company_name, dba_name,
 * usps_mailer_id, company_registration_id) are optional so Next/Save work without validating hidden fields.
 */
export const createCompanySchema = (isListAdmin?: boolean): SchemaOf<IPafClientForm> => {
    return object({
        /* ---------- COMPANY ---------- */
        company__company_name: string().label(companyAEFields.companyName.label).max(128).required(),
        company__parent_company_name: string().label(companyAEFields.parentCompanyName.label).max(128).optional(),
        company__dba_name: string().label(companyAEFields.dbaName.label).max(128).optional(),
        company__federal_tax_id: string().label(companyAEFields.federalTaxId.label).max(30).optional(),
        company__usps_mailer_id: string().label(companyAEFields.uspsMailerId.label).max(30).optional(),
        company__carrier_route_id: string().label("Carrier Route ID").max(25).optional(),
        company__company_registration_id: string().label(companyAEFields.customerRegistrationId.label).max(15).optional(),
        company__company_website: string().label(companyAEFields.companyWebsite.label).max(128).optional(),
        company__customer_since_date: string().label(companyAEFields.customerSinceDate.label).optional(),
        is_foreign_location: boolean().label(companyAEFields.isForeignLocation.label).required(),
        is_ncoa: boolean().label(companyAEFields.isNcoa.label).required(),
        is_dsf: boolean().label(companyAEFields.isDsf.label).required(),
        is_triplex: boolean().label(companyAEFields.isTriplex.label).required(),
        is_waiver_on_file: boolean().label(companyAEFields.isWaiverOnFile.label).required(),
        company__naics_code: string().label(companyAEFields.naicsCode.label).max(10).required(),
        company__address1: string().label(companyAEFields.address1.label).max(80).required(),
        company__address2: string().label(companyAEFields.address2.label).max(80).optional(),
        company__city: string().label(companyAEFields.city.label).max(80).required(),
        company__state: string().label(companyAEFields.state.label).max(5).required(),
        company__postal_code: string().label(companyAEFields.postalCode.label).max(25).required(),
        company__urbanization: string().label(companyAEFields.urbanization.label).max(28).optional(),
        company__phone: string().label(companyAEFields.phone.label).max(25).required(),
        company__representative_name: string().label(companyAEFields.representativeName.label).max(100).required(),
        company__representative_title: string().label(companyAEFields.representativeTitle.label).max(100).optional(),
        company__representative_email: string().email().label(companyAEFields.representativeEmail.label).max(128).required(),
        company__is_deleted: boolean().label(companyAEFields.customerIsDeleted.label).optional(),
        company__is_internal: boolean().label(companyAEFields.customerIsInternal.label).optional(),
        is_deleted: boolean().label(companyAEFields.isDeleted.label).optional(),
        /* ---------- ListAdmin-only (optional) ---------- */
        listadmin_type: number()
            .integer()
            .optional()
            .transform((_v, o) => (o === "" || o === null || o === undefined ? undefined : Number(o))),
        notes: string().max(2048).optional(),
    })
}
